/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useState } from "react";
import { ReconMediaBatchResource, MBReconJustification } from "../reconcileMediaBatch.types";

interface Props {
  row: ReconMediaBatchResource;
  justifications: Record<string, MBReconJustification>;
  hasDeviation: (row: ReconMediaBatchResource) => boolean;
  handleReasonChange: (lot_reference: string, value: string, resource_type: string) => void;
}

const MBDeviationInput: React.FC<Props> = ({ row, justifications, hasDeviation, handleReasonChange }) => {
  const [touched, setTouched] = useState(false);
  const hasDev = hasDeviation(row);
  const isMissing = hasDev && touched && !justifications[row.lot_reference]?.deviation_reason;

  return (
    <input
      type="text"
      value={justifications[row.lot_reference]?.deviation_reason || ""}
      required={hasDev}
      onChange={(e) => handleReasonChange(row.lot_reference, e.target.value, row.resource_type)}
      onBlur={() => setTouched(true)}
      disabled={!hasDev}
      placeholder={hasDev ? "Required justification..." : "N/A"}
      className={`w-full py-1.5 px-3 border rounded-lg text-xs font-bold transition-all ${
        isMissing
          ? "bg-red-50 border-red-400 focus:ring-red-500 focus:border-red-500 text-slate-800"
          : hasDev
            ? "bg-white border-orange-200 focus:ring-orange-500 focus:border-orange-500 text-slate-800"
            : "bg-slate-50 border-slate-100 text-slate-400 cursor-not-allowed"
      }`}
    />
  );
};

export default MBDeviationInput;
